var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notfound-wrapper"},[_c('div',[_vm._v("404 - Page not found")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Вернуться на главную страницу")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }